import "./bootstrap.js";
import "../css/app.css";
import "remixicon/fonts/remixicon.css";

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { InertiaProgress } from "@inertiajs/progress";
import ImageHelper from "./Helpers/image_helper";
import DateHelper from "./Helpers/date_helper";
import CurrencyHelper from "./Helpers/currency_helper";
import { VueMasonryPlugin } from "vue-masonry";
import inertiaTitle from "inertia-title/vue3";
import { createPinia } from "pinia";
import VueSocialSharing from "vue-social-sharing";

createInertiaApp({
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(VueMasonryPlugin)
            .use(inertiaTitle)
            .use(createPinia())
            .use(VueSocialSharing)
            .mixin(ImageHelper)
            .mixin(DateHelper)
            .mixin(CurrencyHelper)
            .mixin({ methods: { route } })
            .mount(el);
    },
});

InertiaProgress.init({
    delay: 0,
    color: "#4c9ac7",
    includeCSS: true,
    showSpinner: false,
});
